import React, { useState } from "react";
import { BUILD_ID, checkForNewBuild, hardRefresh, lastCheck, deploymentLinkHost, mainAddressFor } from "./appUpdate.js";

export default function AppUpdateCard() {
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);
  const frozen = deploymentLinkHost();

  async function check() {
    setBusy(true); setMsg(""); setInfo(null);
    const r = await checkForNewBuild({ manual: true });
    setBusy(false);
    setInfo(lastCheck);
    setMsg(r === "current" ? "This is the newest version your server is publishing." : r === "updating" ? "A newer version was found. Updating…" : "Couldn't check right now. Try again when you're online.");
  }

  return (
    <div className="bg-card rounded-2xl p-4 mb-5">
      <div className="text-sm font-semibold">App version</div>
      <div className="text-xs text-ivory-dim mt-1">Build <span className="v-mono">{BUILD_ID}</span>. Updates normally install by themselves; use this if you think you're on an old version. Your data isn't affected.</div>

      {frozen && (
        <div className="mt-3 rounded-lg px-3 py-2.5 text-xs leading-relaxed" style={{ background: "var(--brass-dim)" }}>
          You're on a one-off deployment link (<span className="v-mono">{frozen}</span>). These copies are frozen and never update, which is why checking says "latest". Open <a className="underline text-brass font-medium" href={`https://${mainAddressFor(frozen)}`}>https://{mainAddressFor(frozen)}</a> instead, and install the app from there.
        </div>
      )}

      <div className="mt-3 flex gap-2">
        <button onClick={check} disabled={busy} className="flex-1 bg-card2 rounded-full py-2 text-sm font-medium disabled:opacity-50">{busy ? "Checking…" : "Check for updates"}</button>
        <button onClick={() => { if (window.confirm("Reload a fresh copy of the app? Your data stays.")) hardRefresh(); }} className="flex-1 bg-card2 rounded-full py-2 text-sm font-medium">Reload fresh copy</button>
      </div>
      {msg && <div className="text-xs text-ivory-dim mt-2">{msg}</div>}
      {info && (
        <div className="text-[11px] text-ivory-dim mt-2 leading-relaxed v-mono">
          Address: {info.host}<br />This device: {info.running}<br />Published: {info.latest || "unknown"}{info.cache ? <><br />Server cache: {info.cache}</> : null}
        </div>
      )}
    </div>
  );
}
